import { create } from 'zustand';

interface SharedState {
  activeKey: string;
  setActiveKey: (key: string) => void;
}

export const useSharedStore = create<SharedState>((set) => ({
  activeKey: "1",
  setActiveKey: (key) => set({ activeKey: key }),
}));
